import { ResourceMobilizationStateTypes, ResourceMobilizationActionTypes } from "./ResourceMobilization.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: ResourceMobilizationStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const ResourceMobilizationReducer = (
  state: ResourceMobilizationStateTypes = INITIAL_STATE,
  action: any
): ResourceMobilizationStateTypes => {
  switch (action.type) {
    case ResourceMobilizationActionTypes.FETCH_ALL_RESOURCE_MOBILIZATION:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case ResourceMobilizationActionTypes.FETCH_ALL_RESOURCE_MOBILIZATION_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case ResourceMobilizationActionTypes.FETCH_ALL_RESOURCE_MOBILIZATION_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case ResourceMobilizationActionTypes.FETCH_ALL_RESOURCE_MOBILIZATION_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case ResourceMobilizationActionTypes.FETCH_ONE_RESOURCE_MOBILIZATION:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case ResourceMobilizationActionTypes.FETCH_ONE_RESOURCE_MOBILIZATION_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case ResourceMobilizationActionTypes.FETCH_ONE_RESOURCE_MOBILIZATION_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case ResourceMobilizationActionTypes.FETCH_ONE_RESOURCE_MOBILIZATION_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default ResourceMobilizationReducer;
